import React from "react";
import { Link } from "react-router-dom";
import {
  FaFacebook,
  FaTwitter,
  FaInstagram,
  FaLinkedin,
  FaMapMarkerAlt,
  FaEnvelope,
} from "react-icons/fa";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#135879] text-white border-t-2 border-[#d4af37] pt-12 pb-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 items-start justify-center gap-8 mb-8">
          {/* About Column */}
          <div className="mb-6 md:mb-0">
            <h3 className="text-xl font-bold mb-4 text-[#d4af37]">
              Al-Tijarat Raabehah
            </h3>
            <p className="mb-4 text-gray-300">
              Empowering our community through business growth, networking, and
              economic development.
            </p>
            <div className="flex space-x-4">
              <a
                href="#"
                className="text-gray-300 hover:text-[#d4af37] transition-colors"
              >
                <FaFacebook size={20} />
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-[#d4af37] transition-colors"
              >
                <FaTwitter size={20} />
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-[#d4af37] transition-colors"
              >
                <FaInstagram size={20} />
              </a>
              <a
                href="#"
                className="text-gray-300 hover:text-[#d4af37] transition-colors"
              >
                <FaLinkedin size={20} />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#d4af37]">
              Quick Links
            </h3>
            <ul className="space-y-2">
              <li>
                <Link
                  to="/"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors block"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/business-directory"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors block"
                >
                  Business Directory
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors block"
                >
                  About Us
                </Link>
              </li>
              <li>
                <Link
                  to="/events"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors block"
                >
                  Events
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors block"
                >
                  Contact Us
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4 text-[#d4af37]">
              Contact Us
            </h3>
            <ul className="space-y-3">
              <li className="flex items-start">
                <FaMapMarkerAlt className="text-[#d4af37] mt-1 mr-3 flex-shrink-0" />
                <span className="text-gray-300">
                  10S252 Kingery Hwy (Rt 83)
                  <br />
                  Willowbrook, IL 60527
                </span>
              </li>
              <li className="flex items-center">
                <FaEnvelope className="text-[#d4af37] mr-3" />
                <a
                  href="mailto:tr@chicagojamaat.org"
                  className="text-gray-300 hover:text-[#d4af37] transition-colors break-all"
                >
                  tr@chicagojamaat.org
                </a>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-gray-700 pt-6 mt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-gray-400 text-sm mb-4 md:mb-0">
              &copy; {currentYear} Al-Tijarat Raabehah Chicago. All rights
              reserved.
            </p>
            <div className="flex space-x-6">
              <Link
                to="/privacy-policy"
                className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors"
              >
                Privacy Policy
              </Link>
              <Link
                to="/terms"
                className="text-gray-400 hover:text-[#d4af37] text-sm transition-colors"
              >
                Terms of Service
              </Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
